
// export const crumbsArr = (state) => {
//     return state.crumbsArr;
// }

const getters = {
    // crumbsArr: (state) => {
    //     return state.crumbsArr;
    // },
};

export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js